module.exports = __webpack_public_path__ + "img/bild5.71feed8f.jpeg";